import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Toggle } from '@pwc/pwc-deals-ui';
import { adjustmentToggledThunk } from '../../../../common/engine/actions/adjustmentToggled';

const AdjustmentToggle = ({
  isActive,
  disabled,
  documentCode,
  adjustmentType,
  adjustmentKey,
}) => {
  const dispatch = useDispatch();

  const toggleAdjustment = () => {
    dispatch(
      adjustmentToggledThunk(
        documentCode,
        adjustmentType,
        adjustmentKey,
        !isActive
      )
    );
  };

  return (
    <Toggle
      checked={isActive}
      disabled={disabled}
      name={`toggle-adjustment-${adjustmentKey}`}
      dataTestId={`toggle-adjustment-${adjustmentKey}`}
      onClick={() => toggleAdjustment()}
    />
  );
};

AdjustmentToggle.propTypes = {
  isActive: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  documentCode: PropTypes.string.isRequired,
  adjustmentType: PropTypes.string.isRequired,
  adjustmentKey: PropTypes.string.isRequired,
};

export default AdjustmentToggle;
